export default function (state, getters, rootState, rootGetters) {
    let items = [];
    if (!rootGetters.permission(48)) items = items.concat([1, 2]);
    if (!rootGetters.permission(49)) items = items.concat([3]);
    return items;
}